var React = require('react');

function LogoEasyBetShort (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0","y":"0","fill":"#333333","height":"100%","width":"100%","key":0}),React.createElement("path",{"fill":"white","d":"M16.32 13.9c-.7 0-1.62.22-1.62-.76 0-.87.73-1.79 1.62-1.79 1 0 1.59.76 1.59 1.73 0 .97-.86.81-1.59.81Zm5.1 2.6c.86 0 1.67-.24 1.67-2.03 0-2.03-2.02-5.57-6.61-5.57-4.05 0-7.58 3.03-7.58 7.2 0 3.49 2.51 7.01 7.36 7.01 2.43 0 6.23-1.52 6.23-3.6 0-.51-.49-1.35-1.05-1.35s-1.56 1.22-3.59 1.22c-1.27 0-3.02-1.14-3.02-2.49 0-.46.43-.38.73-.38h5.85Z","key":1})]);
}

LogoEasyBetShort.defaultProps = {"viewBox":"0 0 31 31"};

module.exports = LogoEasyBetShort;

LogoEasyBetShort.default = LogoEasyBetShort;
